import { Checkbox as MuiCheckbox } from '@mui/material';

import Icon from '../Icon';
import { checkboxSx } from './styles';

import type * as React from 'react';
import type { CheckboxProps as MuiCheckboxProps } from '@mui/material';
import type { ThemeProps } from '@toolbox/style/theme/common/ThemeProvider/ThemeProvider';

export interface CheckboxProps
  extends Omit<MuiCheckboxProps, 'disableRipple' | 'checkedIcon' | 'icon'> {
  showRipple?: boolean;
}

const Checkbox: React.FC<CheckboxProps> = ({ sx, showRipple = false, ...other }) => {
  return (
    <MuiCheckbox
      sx={checkboxSx(sx)}
      icon={<Icon icon="check-box" />}
      checkedIcon={<Icon icon="check-box-checked" />}
      disableRipple={!showRipple}
      {...(other as ThemeProps)}
    />
  );
};

export default Checkbox;
